import { Input, InputProps } from "./Input";

/**
 * Le due caselle dell'orario di un appuntamento — inizio e fine — come si
 * presentano in tutti e tre i moduli che ce l'hanno: interventi, installazioni
 * e attivazioni.
 *
 * Un componente e non due `<Input type="time">` ripetuti tre volte perché le
 * etichette e la riga di spiegazione devono dire la stessa cosa ovunque: è la
 * stessa ragione per cui la conversione dell'orario, in backend, sta in un
 * modulo solo. Tre copie divergerebbero al primo ritocco.
 *
 * `type="time"` e non un campo libero: la tastiera giusta sul telefono, il
 * formato 24 ore imposto dal browser, e un valore che arriva già come `HH:MM`
 * — cioè esattamente quello che la colonna `TIME` si aspetta.
 *
 * Le due estremità sono indipendenti: si può indicare solo l'ora d'inizio (il
 * caso normale) e lasciare vuota l'altra. Non c'è nessun controllo che
 * imponga fine > inizio, perché non c'è nessun caso reale in cui serva
 * bloccare chi sta compilando.
 */
export function CampiOrario({
  inizio,
  fine,
  nota = "Facoltativi. Servono al Calendario, che senza orario può mostrare solo il giorno.",
  disabilitato,
}: {
  /** Props della casella d'inizio: `{...register("orario_inizio")}` o `value`/`onChange`. */
  inizio: InputProps;
  /** Props della casella di fine, stessa forma. */
  fine: InputProps;
  /** Riga di spiegazione sotto le due caselle. */
  nota?: string;
  disabilitato?: boolean;
}) {
  return (
    <div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Input label="Ora inizio" type="time" disabled={disabilitato} {...inizio} />
        <Input label="Ora fine" type="time" disabled={disabilitato} {...fine} />
      </div>
      {nota && <p className="mt-1.5 text-xs text-ink/50">{nota}</p>}
    </div>
  );
}
